import { btnSecondaryCss } from "@components/Button/utils/constants";
import { MyBTObject } from "@features/mybt/utlis/types";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { TestIdClassNameProps } from "@typings/Common";
import { cn } from "@util/helpers";

import KeywordFilter from "../KeywordFilter";

export type MyBTCarouselSlideProps = TestIdClassNameProps & {
  /** The object of the carousel. */
  myBTObject: MyBTObject;
  /** Whether to disable the paywall. */
  disablePaywall?: boolean;
  /** The class name for the wrapper of the slide */
  className?: string;
  /** The class name for the divider */
  dividerClassName?: string;
  /** The class name for the icon */
  iconClassName?: string;
  /** The ref code to be added on the keyword filter. */
  refCode?: string;
};

/**
 * MyBTCarouselSlide is a component that displays a slide of MyBT objects.
 */
const MyBTCarouselSlide = ({
  testId,
  className,
  myBTObject: { tag, items: articles },
  dividerClassName,
  iconClassName,
  refCode,
}: MyBTCarouselSlideProps): React.ReactElement => {
  if (articles.length === 0) return <></>;

  return (
    <div
      className={cn("h-full border border-gray-850 p-4", className)}
      data-testid={testId}
    >
      {tag.urlPath ? (
        <KeywordFilter
          tag={tag}
          tagClassName="px-0"
          iconClassName={iconClassName}
          buttonClassName={cn(btnSecondaryCss, "p-2")}
          disableTooltip
          disableBorder
          testId={testId ? `${testId}-mybt-keyword-button` : undefined}
          refCode={refCode}
        />
      ) : null}

      <div
        className={cn(
          "stories divide mt-3 divide-y divide-gray-175 border-t border-gray-175",
          dividerClassName
        )}
      >
        {articles?.map((cardProps, index) => {
          const variant: CardVariations = {
            image: {
              width: "w-3/10",
              position: "right",
              aspectRatio: "aspect-square object-cover",
              filters: { w: ImagePresets.SMALL, dpr: 1, f: "webp" },
            },
            content: {
              width: index === 0 ? "w-7/10" : "w-full",
              extraClass: "mr-4",
            },

            title: {
              color: "text-gray-850",
              size: "text-base",
              extraClass: "my-0 font-lct font-bold",
            },
          };

          return (
            <Card
              key={cardProps.id}
              {...cardProps}
              variations={variant}
              className="py-3"
            />
          );
        })}
      </div>
    </div>
  );
};

export default MyBTCarouselSlide;
